import React, { useEffect, useRef, useState, ChangeEvent, useMemo, useContext } from 'react';
import { useAuth } from '@/lib/auth';
import { useServices } from '../api/getServices';
import { useGetAllServices, useRefValue } from '@/features/services/api/getServices';
import appCompoLoading from '@/assets/animation/loading.json';
import Lottie from 'lottie-react';
import Dropdown from 'react-bootstrap/Dropdown';
import ListCheck from '@/assets/img/list-check-icon.svg';
import DownArrow from '@/assets/img/down-arrow.svg';

import CloseIcon from '@/assets/img/Close-new.svg';

import '../../events/components/AddNewPet.scss';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import { Day } from 'react-modern-calendar-datepicker';
import AddNewPink from '@/assets/img/add-new-pink.svg';
import { Refreshicon } from '@/assets/img/refresh';
import { default as ReactSelect, components } from 'react-select';
import { BookAppointmentDTO, useBookAppointMent } from '../api/bookAppointment';
import { BookAppointmentResponse, Slot } from '../types';
import 'react-calendar/dist/Calendar.css';

import moment from 'moment-timezone';
import { Service } from '@/features/services';
import { useCalenderUsers } from '../api/getCalenderUsers';
import { showNotification } from '@/utils/notificationUtils';
import { CalendarUsers, RecurringDetails } from '@/features/Calendar/types';
import { useGetAvailabilities } from '../api/getAvailability';
import { useSyncAppointment } from '../api/syncAppointments';
import WelcomeDialog from '@/components/WelcomeDialog';
import storage from '@/utils/storage';
import './Availablity.scss';
import Utils from '@/utils/util';
import { BookAppointmentDialog } from '../components/BookAppointmentDialog';
import { Slots } from '../components/Slots';
import { ScheduleView } from '../components/ScheduleView';
import { Button } from '@/components/Elements';
import { Heading } from '@/components/Elements/Heading';
import 'react-phone-input-2/lib/style.css'; // You may need to import the stylesheet as well
import PhoneInput from 'react-phone-input-2';
import countryList from 'react-select-country-list';
import { Business } from '@/features/business';
import { useSilentGetLocation } from '@/features/location/api/locationRequests';
import { useGetCustomers, useGetCustomersDetails } from '@/features/customers/api/getCustomerList';
import { Customers, Pets } from '@/features/customers';
import { useParams } from 'react-router-dom';
import { PetListDetails } from '../components/petListDetails';
import { DurationPicker } from '../components/DurationPicker';
import { Room } from '@/features/rooms';
import { ServiceTypes } from '@/components/Elements/ServiceTypes';
import { useGetBookingCost } from '../api/getRoomsBoradingCost';
import { useGetRooms } from '@/features/rooms/api/getRoomsList';
import { useTranslation } from 'react-i18next';
import { UserContext } from '@/routes';
import { DropDown } from '@/components/dropdown/DropDown';
import { PetForm } from '../components/PetForm';
import { ServiceDetail } from '@/features/events';
import { businessCurrency } from '@/features/Language/api/getCountryCurrency';
import ConfirmationDialogV2 from '@/components/Elements/ConfirmationDialog/ConfirmationDialogV2';
import { Recurring } from '../components/Recurring';
import { RecurringAppointment } from '../api/getRecurringSlots';
import { ToggleButton } from '@/components/Elements/ToggleButton';
import { BookedSlots } from '../components/BookedSlots';
import { ALLOWED_PHONE_COUNTRIES } from '@/config';
import { SelectedServiceProviders } from '@/features/services/components/SelectedServiceProviders';
import UserIcon from '@/assets/img/user-default-icon.png';


const OptionSP = (props: any) => {
  const {
    data: { avatarUrl, name, email },
  } = props;
  return (
    <div key={`options-sp${props.value}`}>
      <components.Option {...props}>
        <div className="service-provider-option">
          <div className="left-details">
            <img
              className="rounded-full border-0"
              src={avatarUrl ? avatarUrl : UserIcon}
              referrerPolicy="no-referrer"
            />
            <span>
              <label className="name">{name}</label>
              <label className="email">{email}</label>
            </span>
          </div>
          <label htmlFor={`option-check-${props.value}`} className="check-container">
            <input checked={props.isSelected} id={`option-check-${props.value}`} type="checkbox" />
            <span className="checkmark"></span>
          </label>
        </div>
      </components.Option>
    </div>
  );
};

const ValueContainerSP = (props: any) => {
  const valueLength = props.getValue().length;
  return (
    <components.ValueContainer {...props}>
      {valueLength === 0 && <span className="react-select-custom-placeholder">Select Members</span>}
      {props.getValue().length > 0 &&
        !props.selectProps.inputValue &&
        `+${valueLength} Member${valueLength != 1 ? 's' : ''} added`}
      {React.Children.map(props.children, (child) => {
        return child?.type === components.Input ? child : null;
      })}
    </components.ValueContainer>
  );
};

type AvailabilityProps = {
  selectedSlot?: any;
  onClose?: (hide: boolean) => void;
};
export const Availablity = ({ selectedSlot, onClose }: AvailabilityProps) => {
  const userContext = useContext(UserContext);
  const { t, i18n } = useTranslation();
  const { user } = useAuth();
  const currency = businessCurrency(user, 'USD');
  const countries = useMemo(() => countryList().getData(), []);
  const getServicesMutation = useGetAllServices();
  const roomsMutation = useGetRooms();
  const useGetRoomBoardingCostMutation = useGetBookingCost();

  const useGetEventsMutation = useGetCustomersDetails();
  const useGetCustomersMutation = useGetCustomers();
  const { petParentId } = useParams();
  const useRefEvents = useRefValue();
  const [bookingConfirmed, setBookingConfirmed] = useState(false);
  const [selectedDuration, setSelectedDuration] = useState<number>(-1);
  const [totalPetCount, setTotalPetCount] = useState<number>(1);
  const [selectedDate, setSelectedDate] = useState(
    Utils.fromServerTz(
      selectedSlot ? new Date(selectedSlot.start) : new Date(),
      user?.activeLocation?.timezone
    )
  );
  const [serviceList, setServiceList] = useState<Service[]>();
  const [subServiceList, setSubServiceList] = useState<Service[]>();
  const [amslots, setAMSlots] = useState<Slot[]>();
  const [pmslots, setPMSlots] = useState<Slot[]>();
  const [showNonBusinessHoursSlots, setShowNonBusinessHoursSlots] = useState(false);
  const [selectedAddonServices, setSelectedAddonsServices] = useState<Service[]>();
  const [addonServices, setAddonServices] = useState<Service[]>();

  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [phoneCountryData, setPhoneCountryData] = useState<any>(null);
  const [firstName, setFirstName] = useState('');
  const [selectedTimeSlot, setSelectedTimeSlot] = useState<Slot>();
  // const [startTime, setStartTime] = useState('');
  // const [endTime, setEndTime] = useState('');
  const [homeAddress, setHomeAddress] = useState<any>();
  const [country, setCountry] = useState<any>();
  const [zipcode, setZipCode] = useState<any>();
  const [businessData, setBusinessData] = useState<Business>();

  const [calenderUsers, setCalenderUsers] = useState<CalendarUsers[]>();
  const [selectedProviders, setSelectedProviders] = useState<CalendarUsers[]>();

  const isInvitation = storage.getKey('showCongratulations');
  const [showCongratsDilaog, setShowCongratsDialog] = useState(isInvitation ? true : false);
  const serviceQuery = useServices({ businessId: user?.businessId });
  const [showServiceMenu, setShowMenu] = useState(true);
  //const [selectedCustomerPet, setSelectedCustomersPet] = useState<Pets>();
  const [perDayBookingPrice, setPerDayBookingPrice] = useState(0);

  const [searchTerm, setSearchTerm] = useState('');
  const usersQuery = useCalenderUsers({
    id: user?.businessId,
    filterType: 'active',
  });
  const useGetAvailabilitiesMutation = useGetAvailabilities();
  const updateSilentGetLocation = useSilentGetLocation();
  const useSyncMutation = useSyncAppointment();
  const [selectedService, setSelectedService] = useState<Service>();
  const [selectedSubService, setSelectedSubService] = useState<Service>();
  const [selectedServiceProvider, setSelectedServiceProvider] = useState<CalendarUsers>();
  const [bookingResponse, setBookingResponse] = useState<BookAppointmentResponse>();
  const [showMoreBookingDetails, setShowMoreBookingDetails] = useState(false);
  const [customersList, setCustomersList] = useState<Customers[]>([]);
  const [selectedCustomer, setSelectedCustomer] = useState<Customers>();
  const [rooms, setRooms] = useState<Room[]>();
  const [selectedRoom, setSelectedRoom] = useState<Room>();
  const [selectedBookingView, setSelectedBookingView] = useState<string>('grooming');
  const [roomsBookingDateRange, setRoomsBookingDateRange] = useState<any>();
  const [colorList, setColorList] = useState<any>();
  const [selectedExistingPets, setSelectedExistingPets] = useState<Pets[]>([]);
  const [newPets, setNewPets] = useState<Pets[]>([]);
  const [selectedNewPetIndex, setSelectedNewPetIndex] = useState<number>(-1);
  const [showAddPetForm, setShowAddPetForm] = useState<boolean>(true);
  const [showAppointmentConfirmationModal, setShowAppointmentConfirmationModal] = useState(false);
  const [recurringDetails, setRecurringDetails] = useState<RecurringDetails>({
    isRecurring: false,
    recurringSlots: [],
    recurringFrequency: 'weekly',
    recurringCount: 0,
  });
  const firstRender = useRef(true);

  const [day, setDay] = useState<Day>({
    day: moment().date(),
    month: moment().month() + 1,
    year: moment().year(),
  } as Day);
  const [breedList, setBreedList] = useState<any>();

  const bookAppointmentMutation = useBookAppointMent();

  const getLocationData = async () => {
    const response = await updateSilentGetLocation.mutateAsync({});
    setBusinessData({ ...response });
  };

  useEffect(() => {
    const offering = user?.offerings?.grooming
      ? 'grooming'
      : user?.offerings?.daycare
        ? 'daycare'
        : 'boarding';
    setSelectedBookingView(
      user?.offerings?.grooming ? 'grooming' : user?.offerings?.daycare ? 'daycare' : 'boarding'
    );
    if (offering !== 'grooming') {
      fetchService();
    }
    fetchPetTypes();
  }, []);
  useEffect(() => {
    if (roomsBookingDateRange && roomsBookingDateRange.startDate && roomsBookingDateRange.endDate) {
      onGetBookingPrice({
        startDate: roomsBookingDateRange.startDate,
        endDate: roomsBookingDateRange.endDate,
      });
    }
  }, [totalPetCount]);

  const resetData = () => {
    setEmail('');
    setPhone('+1');
    setFirstName('');
    setSelectedDate(Utils.fromServerTz(new Date(), user?.activeLocation?.timezone));
    setHomeAddress('');
    setCountry('');
    setZipCode('');
    setSelectedDuration(selectedBookingView === 'daycare' ? 60 : -1);
    // setStartTime('');
    // setEndTime('');
    setSelectedTimeSlot(undefined);
    setSelectedCustomer(undefined);
    setSelectedAddonsServices([]);
    setSelectedRoom(undefined);
    setSelectedService(undefined);
    setSelectedSubService(undefined);
    setRooms([]);
    resetAddNewPet(true);
    setSelectedProviders([]);
    //console.log('setting to empty pets ********* 1');

    setNewPets([]);
    setSelectedExistingPets([]);
    setSelectedNewPetIndex(-1);
    setRoomsBookingDateRange(undefined);
    setPerDayBookingPrice(0);
    setTimeout(() => {
      if (selectedBookingView === 'daycare' || selectedBookingView === 'boarding') {
        fetchService();
      } else {
        updateSp();
      }
    }, 200);
  };
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    resetData();
  }, [selectedBookingView]);

  useEffect(() => {
    if (serviceList && serviceList.length == 0) {
      setShowMenu(false);
    } else {
      setShowMenu(true);
    }
  }, [serviceList]);

  useEffect(() => {
    if (selectedDuration >= 0) {
      fetchData();
    }
  }, [selectedDate, selectedDuration]);

  useEffect(() => {
    if (petParentId) {
      getCustomerDetails();
    }
    getCustomersList();
  }, [petParentId]);

  useEffect(() => {
    if (
      selectedBookingView === 'daycare' ||
      (selectedBookingView === 'grooming' && !selectedService)
    ) {
      return;
    }
    let pet = undefined;
    if (selectedExistingPets.length > 0) {
      pet = selectedExistingPets[0];
    } else if (newPets.length > 0) {
      pet = newPets[0];
    }
    if (pet && !pet.id) {
      setSelectedDuration(
        selectedSubService
          ? Utils.getDurationFromService(selectedSubService, pet.petSize)
          : Utils.getDurationFromService(selectedService, pet.petSize)
      );
      return;
    }

    const foundPref: any =
      pet &&
      pet.servicePrefs?.find((pref) =>
        subServiceList
          ? selectedSubService && Number(pref.serviceId) === Number(selectedSubService.id)
          : Number(pref.serviceId) === Number(selectedService?.id)
      );

    if (foundPref) {
      setSelectedDuration(foundPref.duration);
    } else {
      setSelectedDuration(
        selectedSubService
          ? Utils.getDurationFromService(selectedSubService, pet?.petSize)
          : Utils.getDurationFromService(selectedService, pet?.petSize)
      );
    }
  }, [selectedService, newPets, selectedExistingPets, roomsBookingDateRange]);

  useEffect(() => {
    if (selectedBookingView !== 'grooming') {
      if (selectedDuration != 60) {
        setSelectedDuration(60);
      } else {
        fetchData();
      }
    }
  }, [selectedRoom]);

  useEffect(() => { }, [showNonBusinessHoursSlots]);

  const getCustomersList = async () => {
    const res = await useGetCustomersMutation.mutateAsync({
      businessId: user?.businessId,
      page: 1,
      perPage: 100,
      businessLocationId: user?.activeLocationId,
      petTypes: user?.offerings?.petTypes,
    });
    setCustomersList(res.list);
  };

  const getCustomerDetails = async () => {
    const res = await useGetEventsMutation.mutateAsync({
      id: Number(petParentId),
    });
    if (res && res.pets && res.pets.length > 0) {
      const newCustomersPet = [...res.pets];
    }
    if (res) {
      updateCustomerDetails(res);
    }
  };

  const updateCustomerDetails = (data: Customers) => {
    setSelectedCustomer(data);
    setEmail(data?.email);
    setPhone(data?.phone);
    setFirstName(data?.name);
    setHomeAddress(data?.address);
    setCountry(data?.country);
    //console.log('setting to empty pets ********* 2');
    //setNewPets([]);
    // setSelectedExistingPets([]);
    setSelectedNewPetIndex(-1);
    if (data && data.pets && data.pets.length > 0) {
      if (
        (businessData?.collectPetInfo && selectedBookingView === 'grooming') ||
        selectedBookingView !== 'grooming'
      ) {
        selectCustomerPet(data.pets[0], true);
        // const petServiceable = isPetServicable(data.pets[0].petSize);
        // if (petServiceable) {
        // } else {
        //   setSelectedExistingPets([]);
        //   setNewPets([]);
        // }
      }
    } else if (data && data.pets && data.pets.length === 0) {
      resetAddNewPet(true);
    }
    if (selectedBookingView === 'grooming') {
      if (data?.defaultBusinessUserId) {
        const selectedUser = usersQuery?.data?.list.find(
          (item: any) => Number(item?.id) === Number(data?.defaultBusinessUserId)
        );
        if (selectedUser && selectedUser?.id != selectedServiceProvider?.id) {
          onServiceProviderChange(selectedUser);
        }
      } else {
        if (!selectedServiceProvider) {
          const selectedUser = usersQuery?.data?.list?.[0];
          if (selectedUser) {
            onServiceProviderChange(selectedUser);
          }
        }
      }
    }
    // if (data && data.pets && data.pets.length > 0) {
    //   updateCustomersPetDetails(data.pets[0]);
    // } else if (data && data.pets && data.pets.length === 0) {
    //   resetAddNewPet();
    // }
  };
  const isPetServicable = (selectedPetSize: string) => {
    if (selectedBookingView !== 'grooming') {
      return true;
    }
    const petSizeConfiguration =
      selectedSubService && selectedSubService.petSizePricing
        ? selectedSubService.petSizePricing
        : selectedService?.petSizePricing;
    if (!selectedPetSize) {
      return true;
    }
    if (petSizeConfiguration) {
      const filteredSizeConfiguration =
        petSizeConfiguration[selectedPetSize as keyof typeof petSizeConfiguration];
      if (filteredSizeConfiguration && parseFloat(filteredSizeConfiguration.price as string) > 0) {
        return true;
      }
      return false;
    } else {
      return true;
    }
  };
  const resetCustomerDetails = () => {
    setSelectedCustomer(undefined);
    setEmail('');
    setPhone('');
    setFirstName('');
    setHomeAddress('');
    setCountry('');
    //console.log('setting to empty pets ********* 3');

    //setNewPets([]);
    setSelectedExistingPets([]);
    setSelectedNewPetIndex(-1);
    resetAddNewPet(true);
  };

  const selectCustomerPet = (data: Pets, reset = false) => {
    if (selectedBookingView !== 'grooming') {
      if (reset) {
        if (!isMaximumPetOccupancyReached(reset)) {
          setSelectedExistingPets([data]);
        } else {
          setSelectedExistingPets([]);
        }
      } else {
        const filteredIndex = selectedExistingPets.findIndex((pet) => pet.id === data.id);
        if (filteredIndex >= 0) {
          selectedExistingPets.splice(filteredIndex, 1);
        } else {
          if (!isMaximumPetOccupancyReached()) {
            selectedExistingPets.push(data);
          } else {
            showNotification({
              type: 'info',
              title: 'Max occupancy reached for the selected room',
            });
          }
        }
        setSelectedExistingPets([...selectedExistingPets]);
      }
    } else {
      const petServiceable = isPetServicable(data.petSize);
      if (petServiceable) {
        setSelectedExistingPets([data]);
        resetAddNewPet(false);
        //console.log('setting to empty pets ********* 4');
        setNewPets([]);
      } else {
        //console.log('setting to empty pets ********* 5');
        if (selectedExistingPets.length <= 0) {
          resetAddNewPet(true);
        }
        if (!reset) {
          showNotification({
            type: 'info',
            title:
              'Selected service is not available for this pet, try different pet or change the service',
          });
        } else {
          setSelectedExistingPets([]);
          resetAddNewPet(true);
        }
      }
    }
    if (
      selectedBookingView === 'boarding' &&
      roomsBookingDateRange &&
      roomsBookingDateRange.startDate &&
      roomsBookingDateRange.endDate
    ) {
      onGetBookingPrice(
        {
          startDate: roomsBookingDateRange.startDate,
          endDate: roomsBookingDateRange.endDate,
        },
        newPets.concat(reset ? [data] : selectedExistingPets)
      );
    }
  };
  const resetAddNewPet = (reset = false) => {
    setShowAddPetForm(reset);
  };

  const isMaximumPetOccupancyReached = (reset = false) => {
    const maxOccupancy = selectedBookingView === 'grooming' ? 1 : totalPetCount ? totalPetCount : 1;
    const existingPets = reset ? 0 : selectedExistingPets.length;
    return maxOccupancy > newPets.length + existingPets ? false : true;
  };

  const fetchPetTypes = async () => {
    const res = await useRefEvents.mutateAsync({
      businessId: user?.businessId,
    });
    const convertedArray =
      res &&
      res.breed_list.map((item: any) => ({
        label: item,
        value: item,
        isSelected: false,
      }));
    const convertedPetColorArray =
      res &&
      res.pet_color_list.map((item: any) => ({
        label: item,
        value: item,
        isSelected: false,
      }));
    setColorList(convertedPetColorArray);
    setBreedList(convertedArray);
  };

  const fetchData = async () => {
    if (storage.getToken()) {
      if (
        selectedBookingView === 'boarding' ||
        (selectedBookingView === 'daycare' && !selectedRoom) ||
        (selectedBookingView === 'grooming' && !selectedService?.id) ||
        selectedDuration === -1
      ) {
        return;
      }
      const res = await useGetAvailabilitiesMutation.mutateAsync({
        businessId: user?.businessId,
        duration: selectedDuration,
        date: Utils.toServerTz(selectedDate, user?.activeLocation?.timezone),
        tz: moment.tz.guess(true),
        userId: Number(selectedServiceProvider?.id),
        serviceId: Number(selectedService?.id),
        roomId: selectedRoom ? selectedRoom.id : undefined,
      });
      const amslots: Array<Slot> = [];
      const pmSlots: Array<Slot> = [];
      res.map((item) => {
        let formatedDate;

        if (user?.activeLocation?.timezone) {
          formatedDate = moment(item.start).tz(user?.activeLocation?.timezone).format('hh:mm A');
        } else {
          formatedDate = moment(item.start).format('hh:mm A');
        }

        if (selectedSlot) {
          const selectedSlotTime = moment(selectedSlot.start);
          if (selectedSlotTime.isSame(moment(item.start))) {
            // setStartTime(item.start);
            // setEndTime(item.end);
            setSelectedTimeSlot(item);
          }
        }

        const isBusy = item.status === 'free' ? false : true;
        if (formatedDate.indexOf('PM') > 0) {
          pmSlots.push({ ...item, label: formatedDate, isBusy });
        } else {
          amslots.push({ ...item, label: formatedDate, isBusy });
        }
      });
      setAMSlots(amslots);
      setPMSlots(pmSlots);
    }
  };
  const fetchService = async (userId?: string, parentId: number | null = null) => {
    if (selectedBookingView === 'daycare' || selectedBookingView === 'boarding') {
      const res = await roomsMutation.mutateAsync({
        businessId: user?.businessId,
      });
      setRooms(res.list.filter((room: any) => room.isActive));
      if (!selectedRoom) {
        setSelectedRoom(res.list[0]);
      }
    } else {
      const res = await getServicesMutation.mutateAsync({
        businessId: user?.businessId,
        userId: userId ? Number(userId) : undefined,
        parent: parentId ? Number(parentId) : undefined,
        active: true,
      });
      const services = res?.list || [];
      if (!parentId && services) {
        if (services && services.length > 0 && services[0].isActive === true) {
          setSelectedService(services[0]);
          //setSelectedDuration(Utils.getDurationFromService(services[0], petSize));
          fetchService(undefined, services[0].id ? parseInt(services[0].id) : null);
        }
      }
      if (parentId) {
        setSubServiceList(services);
        // if (services.length == 0) {
        //   setSelectedDuration(0);
        // }
      }
    }
  };

  const updateServiceList = (serviceList: Service[], fetchSubService = false) => {
    const mainsServices: Service[] = [];
    const addonServices: Service[] = [];
    serviceList.forEach((service) => {
      service.isAddonService ? addonServices.push(service) : mainsServices.push(service);
    });
    setServiceList(mainsServices);
    setAddonServices(addonServices);
    if (mainsServices && mainsServices.length > 0) {
      setSelectedService(mainsServices[0]);
      //setSelectedDuration(Utils.getDurationFromService(mainsServices[0], petSize));
      if (fetchSubService) {
        fetchService(undefined, Number(mainsServices[0].id));
      }
    }
  };

  useEffect(() => {
    updateSp();
    getLocationData();
  }, [usersQuery.data]);

  const updateSp = () => {
    if (!(selectedBookingView === 'daycare')) {
      const serviceProviders = usersQuery.data?.list || [];
      let selectedSp: CalendarUsers | undefined;
      if (selectedSlot) {
        selectedSp = serviceProviders.find((sp) => sp.id === selectedSlot.resourceId);

        if (selectedSp) {
          setSelectedServiceProvider(selectedSp);
          selectedSp.services && updateServiceList(selectedSp.services, true);
        }
      }
      if (!selectedSp) {
        if (serviceProviders.length && user?.isAdmin) {
          const sp: CalendarUsers = serviceProviders[0];
          setSelectedServiceProvider(sp);
          sp.services && updateServiceList(sp.services, true);
        } else if (serviceProviders && serviceProviders.length > 0) {
          const sp: CalendarUsers = serviceProviders[0];
          setSelectedServiceProvider(sp);
          sp.services && updateServiceList(sp.services, true);
        }
      }
      setCalenderUsers(serviceProviders);
    }
  };

  if (serviceQuery.isLoading || usersQuery.isLoading) {
    return (
      <div className="h-full w-full flex items-center justify-center">
        <Lottie className="hw-60" animationData={appCompoLoading} />
      </div>
    );
  }

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.id === 'email') {
      setEmail(event.target.value);
    } else if (event.target.id === 'phone') {
      setPhone(event.target.value);
    } else if (event.target.id === 'firstName') {
      setFirstName(event.target.value);
    } else if (event.target.id === 'homeAddress') {
      setHomeAddress(event.target.value);
    } else if (event.target.id === 'zipCode') {
      setZipCode(event.target.value);
    }
  };

  const validate = () => {
    let errorMessage = '';
    if (!firstName || firstName.trim().length < 1) {
      errorMessage = t('please enter the name of the customer');
    } else if (!phone || phone.trim().length < 1) {
      errorMessage = t('please enter valid Phone');
    } else if (!selectedCustomer && phoneCountryData) {
      // This is a new customer, validate phone number based on the country from PhoneInput
      const phoneValidation = Utils.isValidPhoneNumber(phone, phoneCountryData);
      if (!phoneValidation.isValid) {
        errorMessage = phoneValidation.message || t('please enter valid Phone');
      }
    } else if (email && !Utils.isValidEmail(email)) {
      errorMessage = t('please enter valid Email');
    } else if (
      !(selectedBookingView === 'daycare' || selectedBookingView === 'boarding') &&
      !selectedService
    ) {
      errorMessage = t('please select service');
    } else if (selectedBookingView === 'daycare' && !selectedRoom) {
      errorMessage = t('please select room');
    } else if (!(selectedBookingView === 'daycare') && !selectedServiceProvider) {
      errorMessage = 'please select user';
    } else if (
      selectedBookingView !== 'boarding' &&
      (!selectedTimeSlot || !selectedTimeSlot?.start)
    ) {
      errorMessage = 'Please select time slot';
    } else if (selectedBookingView === 'boarding') {
      if (!(roomsBookingDateRange?.startDate && roomsBookingDateRange?.endDate)) {
        errorMessage = 'Please select date range to complete the booking';
      } else if (roomsBookingDateRange?.startDate === roomsBookingDateRange.endDate) {
        errorMessage = 'Please select date range to complete the booking';
      }
    }
    // else if (isRecurringAppointment) {
    //   if (!appointmentRecurringType) {
    //     errorMessage = 'Please select appointment recurring frequency';
    //   } else if (appointmentRecurringCount <= 0) {
    //     errorMessage = 'Please enter valid appointment recurring count';
    //   }
    // }

    if (errorMessage) {
      showNotification({
        type: 'info',
        title: errorMessage,
      });
      return false;
    }
    return true;
  };
  const getReccuringSlotsForBooking = () => {
    const selectedDates: RecurringAppointment[] = [];
    recurringDetails.recurringSlots.forEach((slot: RecurringAppointment) => {
      if (!slot.isDeleted) {
        selectedDates.push({
          startTime: slot.startTime,
          endTime: slot.endTime,
          status: slot.status,
        });
      }
    });
    return selectedDates;
  };
  const scheduleAppointment = async (forceHolidayBooking?: boolean) => {
    if (validate() && !bookAppointmentMutation.isLoading) {
      // let petDetails;

      // if (businessData?.registrationRequired || businessData?.collectPetInfo) {
      //   petDetails = {
      //     name: name,
      //     breed: breed,
      //     gender: selectedGender,
      //     dateOfBirth: dateOfBirth,
      //     weight: Number(weight),
      //     notes: notes,
      //     petType: petType,
      //     petColor: petColor,
      //     petSize,
      //   };
      // }

      if (!forceHolidayBooking && selectedTimeSlot && selectedTimeSlot.isBusy) {
        setShowAppointmentConfirmationModal(true);
        return;
      }

      const pets = newPets.concat(selectedExistingPets);
      const ids = (selectedProviders || []).map((item: any) => item.id);
      const requestData: BookAppointmentDTO = {
        data: {
          email: email ? email.toLowerCase() : undefined,
          phone: phone,
          name: firstName,
          startTime: moment(selectedTimeSlot?.start).toDate(),
          endTime: moment(selectedTimeSlot?.end).toDate(),
          businessUserId: Number(selectedServiceProvider?.id),
          serviceId: selectedSubService
            ? Number(selectedSubService?.id)
            : Number(selectedService?.id),
          summary: selectedService?.name,
          description: `${selectedService?.name} for ${Utils.getDuration(
            selectedDuration || selectedService?.duration
          )}`,
          tz: moment.tz.guess(true),
          businessId: user?.businessId,
          address: homeAddress,
          zip: zipcode,
          state: country,
          petDetails: pets,
          petId: null, //selectedCustomerPet ? Number(selectedCustomerPet?.id) : null,
          duration: selectedDuration,
          roomId: Number(selectedRoom?.id),
          addonSids: getSelectedAddonsIds(),
          startDate: selectedBookingView === 'boarding' ? roomsBookingDateRange?.startDate : null,
          endDate: selectedBookingView === 'boarding' ? roomsBookingDateRange?.endDate : null,
          petCount: totalPetCount,
          allowHoliday: forceHolidayBooking,
          additionalGroomers: ids.length > 0 ? ids : [],
        },
      };
      if (recurringDetails.isRecurring) {
        requestData.data.isRecurring = true;
        requestData.data.recurringFrequency = recurringDetails.recurringFrequency;
        requestData.data.recurringCount = recurringDetails.recurringCount;
        requestData.data.slotsToBook = getReccuringSlotsForBooking();
      }
      try {
        const bookingResponse = await bookAppointmentMutation.mutateAsync(requestData);
        setBookingResponse(bookingResponse);
        setBookingConfirmed(true);
        getCustomersList();
        if (selectedSlot) {
          onClose && onClose(true);
        }
      } catch (e: any) {
        if (e?.response?.data?.errors[0].code === 'ERR161') {
          setShowAppointmentConfirmationModal(true);
        }
      }

      //refreshState();
    }
  };

  const getSelectedAddonsIds = () => {
    let ids = undefined;
    if (selectedAddonServices && selectedAddonServices.length) {
      ids = [];
      selectedAddonServices.forEach((sas) => {
        if (sas.id) {
          ids.push(parseInt(sas.id));
        }
      });
    }
    return ids;
  };

  const getServiceTitle = () => {
    if (serviceList && serviceList.length == 0) {
      return t('No service available');
    } else if (selectedService) {
      return selectedService?.name;
    } else {
      return t('Service Type');
    }
  };

  const getSubServiceTitle = () => {
    if (subServiceList && subServiceList.length == 0) {
      return t('No sub service available');
    } else if (selectedSubService) {
      return selectedSubService?.name;
    } else {
      return undefined;
    }
  };

  const onScheduleDateSelected = (date: any) => {
    setSelectedDate(date);
    // setStartTime('');
    // setEndTime('');
    setShowNonBusinessHoursSlots(false);
    setSelectedTimeSlot(undefined);
  };

  const onServiceProviderChange = (item: CalendarUsers) => {
    setSelectedProviders([]);
    setSelectedServiceProvider(item);
    // setStartTime('');
    // setEndTime('');
    setSelectedTimeSlot(undefined);
    setSelectedService(undefined);
    setSelectedAddonsServices([]);
    setAddonServices([]);
    setSelectedDuration(0);
    setSelectedSubService(undefined);
    setSubServiceList([]);
    setTimeout(() => {
      item.services && updateServiceList(item.services, true);
    }, 100);
  };

  const onServiceSelect = (item: Service) => {
    if (selectedService && selectedService.id === item.id) {
      resetMainService();
      return;
    }
    setSelectedService(item);
    //setSelectedDuration(Utils.getDurationFromService(item, petSize));
    setSelectedSubService(undefined);
    //setSelectedDuration(0);
    setSubServiceList([]);
    item.id && fetchService(undefined, parseInt(item.id));
    // setStartTime('');
    // setEndTime('');
    setSelectedTimeSlot(undefined);
  };
  const onSubServiceSelect = (item: Service) => {
    if (selectedSubService && selectedSubService.id === item.id) {
      resetSubService();
      return;
    }
    setSelectedSubService(item);
    const duration = Utils.getDurationFromService(item);
    setSelectedDuration(duration);
    const pet = selectedExistingPets.length > 0 ? selectedExistingPets[0] : undefined;
    checkForPetServiceability(item, pet?.petSize);
    // setStartTime('');
    // setEndTime('');
    setSelectedTimeSlot(undefined);
  };
  const checkForPetServiceability = (service: Service, petSize?: string) => {
    const isServiceable = isPetSizeServiceable(service, petSize);
    if (!isServiceable) {
      resetAddNewPet(true);
    }
  };

  const isPetSizeServiceable = (service: Service, petSize?: string) => {
    const petSizeConfiguration = service.petSizePricing;
    if (petSize && petSizeConfiguration) {
      const filteredConfig = petSizeConfiguration[petSize as keyof typeof petSizeConfiguration];
      if (filteredConfig && parseFloat(filteredConfig.price as string) > 0) {
        return true;
      }
      return false;
    } else {
      return true;
    }
  };

  const BasicOption = (props: any) => {
    return (
      <div>
        <components.Option {...props}>
          <div className="option-label">{props.label}</div>
        </components.Option>
      </div>
    );
  };
  const getTabVisibility = () => {
    if (bookingConfirmed && userContext && !userContext?.isLandscape) {
      return false;
    } else {
      return true;
    }
  };
  const handleSearchChange = async (e: any) => {
    setSearchTerm(e.target.value);
    const searchString = e.target.value;
    const res = await useGetCustomersMutation.mutateAsync({
      businessId: user?.businessId,
      page: 1,
      perPage: 100,
      businessLocationId: user?.activeLocationId,
      search: searchString,
    });
    //setCustomersList([]);
    setCustomersList(res.list);
  };
  // const onPetSizeChange = (petSize: PetWeight) => {
  //   setPetSize(petSize?.key);
  //   if (selectedBookingView === 0) {
  //     setSelectedDuration(
  //       Utils.getDurationFromService(
  //         selectedSubService ? selectedSubService : selectedService,
  //         petSize?.key
  //       )
  //     );
  //   }
  // };
  const getAddonsPrice = () => {
    let total = 0;
    if (selectedAddonServices && selectedAddonServices?.length > 0) {
      selectedAddonServices.forEach((sas: any) => {
        total = total + parseFloat(sas.price);
      });
    }
    return total;
  };
  const resetMainService = () => {
    setSelectedService(undefined);
    setSelectedAddonsServices([]);
    setAddonServices([]);
    setSelectedSubService(undefined);
    setSelectedDuration(0);
    setSubServiceList([]);
  };

  const resetSubService = () => {
    setSelectedSubService(undefined);
    if (selectedService) {
      const duration = Utils.getDurationFromService(selectedService);
      setSelectedDuration(duration);
    }
  };
  const onDeleteAddonService = (service: Service | ServiceDetail) => {
    const filteredIndex = selectedAddonServices?.findIndex((ss: Service) => {
      return ss.id === service.id;
    });
    if (filteredIndex != undefined && filteredIndex >= 0) {
      selectedAddonServices?.splice(filteredIndex, 1);
      setSelectedAddonsServices([...(selectedAddonServices as Service[])]);
    }
  };
  const onBookingsViewChange = (id: string) => {
    setSelectedBookingView(id);
  };

  const onGetBookingPrice = async (data: any, selectedPets: Pets[] = []) => {
    if (selectedRoom) {
      if (!useGetRoomBoardingCostMutation.isLoading) {
        const res = await useGetRoomBoardingCostMutation.mutateAsync({
          roomId: Number(selectedRoom.id),
          startDate: moment(data.startDate).format('YYYY-MM-DD'),
          endDate: moment(data.endDate).format('YYYY-MM-DD'),
          petDetails: [],
          petCount: totalPetCount,
        });
        if (res) {
          setRoomsBookingDateRange({ startDate: data.startDate, endDate: data.endDate });
          setPerDayBookingPrice(res?.bookingFee);
        }
      } else {
        setPerDayBookingPrice(0);
      }
    }
  };
  const onAddNewPet = (pet: Pets | any) => {
    //console.log('on add new pet called --->');

    if (selectedBookingView === 'grooming') {
      if (!isMaximumPetOccupancyReached()) {
        newPets.push(pet);
      } else {
        newPets.splice(0, 1, { ...pet });
      }
      setNewPets([...newPets]);
    } else if (selectedNewPetIndex >= 0) {
      newPets.splice(selectedNewPetIndex, 1, { ...pet });
      setSelectedNewPetIndex(-1);
    } else {
      if (!isMaximumPetOccupancyReached()) {
        newPets.push(pet);
        setNewPets([...newPets]);
        if (selectedBookingView === 'boarding') {
          onGetBookingPrice(
            {
              startDate: roomsBookingDateRange.startDate,
              endDate: roomsBookingDateRange.endDate,
            },
            newPets.concat(selectedExistingPets)
          );
        }
      } else {
        showNotification({
          type: 'info',
          title: 'Max occupancy reached for the selected room',
        });
      }
    }
  };
  let servicePrice = 0;
  const selectedPets = newPets.concat(selectedExistingPets);
  servicePrice =
    selectedBookingView === 'boarding'
      ? perDayBookingPrice
      : selectedBookingView === 'daycare'
        ? selectedRoom
          ? Utils.getRoomPrice(selectedRoom, selectedDuration, totalPetCount)
          : 0
        : selectedSubService
          ? Utils.getPriceFromServiceAndPets(selectedSubService, selectedPets)
          : Utils.getPriceFromServiceAndPets(selectedService, selectedPets);

  //console.log('calculate service prce ****** ', selectedPets);

  if (!(selectedBookingView === 'daycare' || selectedBookingView === 'boarding')) {
    if (servicePrice >= 0) {
      servicePrice = servicePrice + getAddonsPrice();
    } else {
      servicePrice = getAddonsPrice();
    }
  }
  //const newPets = selectedExistingPets.filter((pet) => (!pet.id ? true : false));
  const onDateRangeChange = (dateRange: any) => {
    if (selectedBookingView === 'boarding') {
      if (dateRange?.startDate && dateRange?.endDate && !useGetRoomBoardingCostMutation.isLoading) {
        onGetBookingPrice({
          startDate: dateRange.startDate,
          endDate: dateRange.endDate,
        });
      }
      return;
    }
  };
  const editNewPetDetails = (index: number) => {
    setSelectedNewPetIndex(index);
  };
  const deleteNewPet = () => {
    newPets.splice(selectedNewPetIndex, 1);
    setNewPets([...newPets]);
    if (selectedBookingView === 'boarding') {
      onGetBookingPrice(
        {
          startDate: roomsBookingDateRange.startDate,
          endDate: roomsBookingDateRange.endDate,
        },
        newPets.concat(selectedExistingPets)
      );
    }
    setSelectedNewPetIndex(-1);
  };

  const onAddPetButtonClick = () => {
    if (selectedBookingView === 'grooming') {
      setSelectedExistingPets([]);
    }
    resetAddNewPet(true);
  };

  const onPetCountChange = (item: number) => {
    const totalPetsSelected = selectedExistingPets.length + newPets.length;
    if (totalPetsSelected > item) {
      if (selectedExistingPets.length > 0) {
        selectedExistingPets.splice(selectedExistingPets.length - 1, 1);
        setSelectedExistingPets([...selectedExistingPets]);
      } else if (newPets.length > 0) {
        newPets.splice(newPets.length - 1, 1);
        setNewPets([...newPets]);
        setSelectedNewPetIndex(-1);
      }
    }
    setTotalPetCount(item);
  };

  const removeProvider = (provider: CalendarUsers) => {
    const filteredIndex = selectedProviders?.findIndex((sp) => {
      return sp.id === provider.id;
    });
    if (filteredIndex != undefined && filteredIndex >= 0) {
      selectedProviders?.splice(filteredIndex, 1);
      setSelectedProviders([...(selectedProviders as CalendarUsers[])]);
    }
  };

  return (
    <>
      {getTabVisibility() && (
        <div className="schedule-page">
          <div className={selectedSlot ? '' : 'col-2-page-layout'}>
            <ScheduleView
              calenderUsers={calenderUsers}
              onScheduleDateChange={onScheduleDateSelected}
              selectedDate={selectedDate}
              setCalenderUsers={(tmp: any) => {
                setCalenderUsers(tmp);
              }}
              selectedRange={roomsBookingDateRange}
              isRoomService={selectedBookingView === 'daycare'}
              isBoardingService={selectedBookingView === 'boarding'}
              onServiceProviderChange={onServiceProviderChange}
              selectedUser={selectedServiceProvider}
              rooms={rooms}
              onSelectRoom={(room) => {
                setSelectedRoom(room);
                setTotalPetCount(1);
                setRoomsBookingDateRange(undefined);
                setPerDayBookingPrice(0);
              }}
              businessData={user?.activeLocation}
              onBookingsViewChange={onBookingsViewChange}
              selectedBookingView={selectedBookingView}
              onGetBookingPrice={(data) => {
                setRoomsBookingDateRange(data);
                onDateRangeChange(data);
              }}
              room={selectedRoom}
            />
            <div className="detail-page">
              <div>
                <div className="card-top-header">
                  <div className="heading-container">
                    <Heading
                      title={Utils.formatDate(selectedDate)}
                      description={`${t('Select the necessary details given below to book')}`}
                      fontWeight="sm"
                    />
                  </div>
                  <div className="refresh-tab">
                    {!(selectedBookingView === 'daycare' || selectedBookingView === 'boarding') && (
                      <>
                        {' '}
                        <DropDown
                          placeholder={t('Select Service')}
                          selectedValue={selectedService?.id}
                          data={serviceList ? serviceList : []}
                          onSelect={(value: any) => {
                            onServiceSelect(value);
                          }}
                          onDismiss={() => { }}
                          enableSearch={true}
                          setObject={true}
                          labelKey="name"
                          valueKey="id"
                          mainClassName="new-figma-drop-down drodpdwon-btn-pink"
                          displayLabel={getServiceTitle()}
                        />
                        {subServiceList && subServiceList.length > 0 && (
                          <DropDown
                            placeholder={t('Select Sub Service')}
                            selectedValue={selectedSubService?.id}
                            data={subServiceList ? subServiceList : []}
                            onSelect={(value: any) => {
                              onSubServiceSelect(value);
                            }}
                            onDismiss={() => { }}
                            enableSearch={true}
                            setObject={true}
                            labelKey="name"
                            valueKey="id"
                            displayLabel={getSubServiceTitle()}
                            mainClassName="new-figma-drop-down drodpdwon-btn-pink"
                          />
                          // <Dropdown className="new-figma-drop-down drodpdwon-btn-pink">
                          //   <Dropdown.Toggle
                          //     title={getSubServiceTitle()}
                          //     variant="success"
                          //     className="drop-down-btn"
                          //     id="dropdown-basic"
                          //   >
                          //     {getSubServiceTitlePlaceholder()}
                          //     {/* {selectedSubService && (
                          //     <CrossIcon className="reset-icon-dropdown" onClick={resetSubService} />
                          //   )} */}
                          //     <img src={DownArrow} className="down-arrow" />
                          //   </Dropdown.Toggle>

                          //   <Dropdown.Menu>
                          //     <div className="menu-scroller">
                          //       {subServiceList?.map((item, index) => {
                          //         return (
                          //           <Dropdown.Item
                          //             className={`${
                          //               selectedSubService && selectedSubService.id == item.id
                          //                 ? 'selected'
                          //                 : ''
                          //             }`}
                          //             onClick={() => onSubServiceSelect(item)}
                          //           >
                          //             <div className="menu-item-minutes">
                          //               <span title={item.name}>{item.name} </span>
                          //               {selectedSubService && selectedSubService.id == item.id ? (
                          //                 <img src={ListCheck} className="ListCheck" />
                          //               ) : null}
                          //             </div>
                          //           </Dropdown.Item>
                          //         );
                          //       })}
                          //     </div>
                          //   </Dropdown.Menu>
                          // </Dropdown>
                        )}
                      </>
                    )}
                  </div>
                </div>
                <div className="content-scroller">
                  <div className="btm-page-design">
                    {userContext && userContext?.isLandscape ? (
                      <div className="title-and-add-btn-row">
                        <Heading
                          size="sm"
                          title={`${t('Booking details')}`}
                          description={
                            selectedCustomer
                              ? t('Select from existing customer')
                              : t('Enter booking information below')
                          }
                          fontWeight="sm"
                        />
                      </div>
                    ) : (
                      <div className="add-new-title existing-customer">
                        {`${t('Select from existing customer')}`}
                      </div>
                    )}

                    <div className="pet-row mt-3 mb-0">
                      {customersList &&
                        (customersList.length > 0 ||
                          (customersList.length == 0 &&
                            (searchTerm || useGetCustomersMutation.isLoading))) && (
                          <>
                            <div className="pet-col-8">
                              <Dropdown className="new-figma-drop-down drodpdwon-btn-pink custom">
                                <Dropdown.Toggle
                                  variant="success"
                                  className={`drop-down-btn fix-height-54 ${selectedCustomer ? '' : 'placeholder-text'
                                    }`}
                                  id="dropdown-basic"
                                >
                                  {selectedCustomer ? selectedCustomer.name : 'Select Customer'}
                                  <img
                                    src={DownArrow}
                                    className={`down-arrow ${selectedCustomer && selectedCustomer?.name ? 'right-30' : ''
                                      }`}
                                  />
                                  {selectedCustomer && selectedCustomer?.name && (
                                    <img
                                      src={CloseIcon}
                                      className="down-arrow set-z-index"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        resetCustomerDetails();
                                      }}
                                    />
                                  )}
                                </Dropdown.Toggle>
                                <Dropdown.Menu style={{ width: '100%' }}>
                                  <div
                                    className="dropdown-item search"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      e.preventDefault();
                                    }}
                                  >
                                    <input
                                      type="text"
                                      className="form-control mb-2"
                                      placeholder={t('Search...')}
                                      value={searchTerm}
                                      onChange={handleSearchChange}
                                    />
                                  </div>
                                  <div className="menu-scroller">
                                    {customersList.map((item: Customers) => (
                                      <Dropdown.Item
                                        key={item.id}
                                        onClick={() => updateCustomerDetails(item)}
                                      >
                                        {item.name}
                                      </Dropdown.Item>
                                    ))}
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                            {!selectedCustomer && (
                              <div className="pet-row mt-2 mb-0 change-display">
                                <div className="horizontal-line"></div>
                                <div className="or-text">{`${t('OR')}`}</div>
                              </div>
                            )}
                          </>
                        )}
                    </div>
                    {!selectedCustomer && (
                      <>
                        <div className="add-new-title">Add new customer </div>
                        {!selectedCustomer && userContext && userContext?.isLandscape && (
                          <div
                            className="more-details customer-alighn-center"
                            onClick={() => setShowMoreBookingDetails(!showMoreBookingDetails)}
                          >
                            {showMoreBookingDetails ? '- Less Details' : '+ More details'}
                          </div>
                        )}
                        <div className="pet-row">
                          <div className="pet-col-4">
                            <input
                              type="text"
                              id="firstName"
                              className="new-cust-input"
                              placeholder={t('Full name')}
                              value={firstName}
                              onChange={handleChange}
                              maxLength={25}
                            />
                          </div>
                          <div className="pet-col-4">
                            <div className="new-figma-phone">
                              <PhoneInput
                                placeholder={`${t('Enter phone number')}`}
                                value={phone}
                                preferredCountries={ALLOWED_PHONE_COUNTRIES}
                                onChange={(value, data) => {
                                  setPhone(value);
                                  setPhoneCountryData(data);
                                }}
                                country={'us'}
                                countryCodeEditable={false}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="pet-row">
                          <div className="pet-col-8">
                            <input
                              className="new-cust-input"
                              placeholder={`${t('Email address')}`}
                              onChange={handleChange}
                              type="email"
                              id="email"
                              value={email}
                            />
                          </div>
                        </div>
                        {userContext && !userContext?.isLandscape && (
                          <div
                            className="more-details mobile-more-details"
                            onClick={() => setShowMoreBookingDetails(!showMoreBookingDetails)}
                          >
                            {showMoreBookingDetails ? '' : '+ More details'}
                          </div>
                        )}
                        {showMoreBookingDetails && (
                          <div>
                            <div className="title-and-add-btn-row mb-3">
                              <Heading
                                size="sm"
                                title=""
                                description={`${t('Enter some extra details below')}`}
                              />
                            </div>
                            <div className="pet-row">
                              <div className="pet-col-8">
                                <input
                                  type="text"
                                  className="new-cust-input"
                                  placeholder={`${t('Enter address lane, city')}`}
                                  value={homeAddress}
                                  id="homeAddress"
                                  onChange={handleChange}
                                />
                              </div>
                            </div>
                            <div className="pet-row">
                              <div className="pet-col-4">
                                <Dropdown className="new-figma-drop-down">
                                  <Dropdown.Toggle
                                    variant="success"
                                    className={`drop-down-btn fix-btn-height ${country ? '' : 'placeholder-text'
                                      }`}
                                    id="dropdown-basic"
                                  >
                                    {country ? country : t('Select country')}
                                    <img src={DownArrow} className="down-arrow" />
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu className="country-drp-menu">
                                    <div className="menu-scroller">
                                      {countries &&
                                        countries?.map((item: any) => {
                                          return (
                                            <Dropdown.Item
                                              onClick={() => {
                                                setCountry(item.label);
                                              }}
                                            >
                                              <div className="menu-item-minutes">{item.label}</div>
                                            </Dropdown.Item>
                                          );
                                        })}
                                    </div>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                              <div className="pet-col-4">
                                <input
                                  type="text"
                                  className="new-cust-input zipcode-input"
                                  placeholder={`${t('Zip code')}`}
                                  value={zipcode}
                                  id="zipCode"
                                  onChange={handleChange}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                        {userContext && !userContext?.isLandscape && showMoreBookingDetails && (
                          <div
                            className="more-details mobile-more-details"
                            onClick={() => setShowMoreBookingDetails(!showMoreBookingDetails)}
                          >
                            {t('- Less Details')}
                          </div>
                        )}
                      </>
                    )}
                    {selectedBookingView === 'daycare' || selectedBookingView === 'boarding' ? (
                      <>
                        <div className="pet-divider"></div>
                        <div
                          className={
                            'flex ' +
                            (userContext?.isLandscape
                              ? !selectedSlot
                                ? 'items-center'
                                : 'flex-col w-full'
                              : 'flex-col w-full')
                          }
                        >
                          {' '}
                          <div className={`booking-title ${selectedSlot ? 'mb-4' : 'mb-0'}`}>
                            <>
                              {' '}
                              <Heading
                                title="Pet Count"
                                description="Select the no of pets for your room booking"
                                size="sm"
                              />
                            </>
                          </div>
                          <div
                            className={
                              'justify-center ' + (userContext?.isLandscape ? 'ml-6' : 'my-3')
                            }
                          >
                            <DurationPicker
                              selectedDuration={totalPetCount}
                              onSelectDuration={onPetCountChange}
                              defaultValues={{
                                step: 1,
                                maxHours: selectedRoom?.maxOccupancy
                                  ? selectedRoom?.maxOccupancy
                                  : 1,
                                enableInput: true,
                              }}
                            />
                          </div>
                        </div>
                        <div className="pet-divider"></div>
                      </>
                    ) : (
                      <></>
                    )}

                    {(selectedBookingView !== 'grooming' || businessData?.collectPetInfo) && (
                      <>
                        {userContext && !userContext?.isLandscape && selectedCustomer && (
                          <div className="pet-divider"></div>
                        )}

                        {userContext && userContext?.isLandscape && selectedCustomer ? (
                          <>
                            {selectedBookingView === 'grooming' && (
                              <div className="pet-divider"></div>
                            )}
                            <div className="title-and-add-btn-row">
                              <div className="pet-booking-titles">
                                <Heading
                                  size="sm"
                                  title={t('Pet details')}
                                  description={t('Select from pre-added pets or add a new')}
                                  fontWeight="sm"
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            {selectedCustomer && (
                              <div className="add-new-title">{t('Select your pet')}</div>
                            )}
                          </>
                        )}
                        {/* <div className="booking-desc">Enter name and breed of your pet</div> */}
                        {selectedCustomer && (
                          <>
                            <div className="pet-row mtop-2 mt-4">
                              {selectedCustomer &&
                                selectedCustomer.pets &&
                                selectedCustomer.pets.length > 0 &&
                                selectedCustomer.pets.map((item: any) => {
                                  const defaultPetType = Utils.getPetTypes(
                                    user?.offerings?.petTypes
                                  );

                                  return !defaultPetType ||
                                    !item.petType ||
                                    defaultPetType === item.petType.toLowerCase() ? (
                                    <PetListDetails
                                      showDeleteOption={false}
                                      data={item}
                                      isSelected={
                                        selectedExistingPets.find((pet) => pet.id === item.id)
                                          ? true
                                          : false
                                      }
                                      onChange={(data: Pets) => {
                                        selectCustomerPet(data);
                                      }}
                                    />
                                  ) : (
                                    <></>
                                  );
                                })}
                              {
                                <div className="add-new-pink-btn" onClick={onAddPetButtonClick}>
                                  <img className="add-pink-btn" src={AddNewPink} />
                                </div>
                              }
                            </div>
                          </>
                        )}
                        {selectedBookingView === 'grooming' && <div className="pet-divider"></div>}
                      </>
                    )}

                    {((businessData?.collectPetInfo && selectedBookingView === 'grooming') ||
                      selectedBookingView !== 'grooming') &&
                      showAddPetForm ? (
                      <div className="add-new-pet-section">
                        {selectedBookingView !== 'grooming' && selectedCustomer && (
                          <div className="pet-divider"></div>
                        )}
                        <Heading
                          customeCss="heading-main-add-new-pet"
                          size="sm"
                          title="Pet Details"
                          fontWeight="sm"
                        />
                        {selectedBookingView !== 'grooming' && (
                          <div className="new-pet-list">
                            {newPets &&
                              newPets.length > 0 &&
                              newPets.map((item: Pets, index: number) => {
                                return (
                                  <PetListDetails
                                    key={`new-pet-${index}`}
                                    data={item}
                                    showDeleteOption={true}
                                    isSelected={selectedNewPetIndex === index ? true : false}
                                    onChange={(data: Pets) => {
                                      editNewPetDetails(index);
                                    }}
                                    onDelete={() => deleteNewPet()}
                                  />
                                );
                              })}
                          </div>
                        )}
                        {((businessData?.collectPetInfo &&
                          selectedBookingView === 'grooming' &&
                          newPets.length <= 1) ||
                          selectedBookingView != 'grooming' ||
                          selectedNewPetIndex >= 0) && (
                            <>
                              <PetForm
                                key={`pet-form`}
                                hideAddNewPet={
                                  selectedBookingView === 'grooming' &&
                                    newPets.length === 1 &&
                                    selectedNewPetIndex < 0
                                    ? true
                                    : false
                                }
                                breedList={breedList}
                                colorList={colorList}
                                selectedCustomer={selectedCustomer}
                                onAddNewPet={(pet) => onAddNewPet(pet)}
                                data={
                                  selectedBookingView !== 'grooming'
                                    ? newPets[selectedNewPetIndex]
                                    : newPets[0]
                                }
                                onDeleteNewPet={() => deleteNewPet()}
                                totalNewPets={newPets.length}
                                selectedBookingView={selectedBookingView}
                                defaultPetType={Utils.getPetTypes(user?.offerings?.petTypes)}
                                availableSizeConfiguration={
                                  selectedSubService
                                    ? selectedSubService?.petSizePricing
                                    : selectedService?.petSizePricing
                                }
                              />
                              {selectedBookingView !== 'boarding' && (
                                <div className="pet-divider"></div>
                              )}
                            </>
                          )}
                      </div>
                    ) : (
                      selectedBookingView !== 'grooming' && <div className="pet-divider"></div>
                    )}
                    {selectedBookingView !== 'boarding' && (
                      <>
                        {!businessData?.collectPetInfo && selectedBookingView === 'grooming' && (
                          <div className="pet-divider"></div>
                        )}
                        <div className="title-and-add-btn-row">
                          <div
                            className={
                              'flex ' +
                              (userContext?.isLandscape
                                ? selectedSlot
                                  ? 'flex-col w-full'
                                  : 'items-center'
                                : 'flex-col w-full')
                            }
                          >
                            <div className={`booking-title ${selectedSlot ? 'mb-4' : 'mb-0'}`}>
                              {selectedBookingView === 'daycare' ||
                                selectedBookingView === 'boarding' ? (
                                <>
                                  {' '}
                                  <Heading
                                    title={t('Booking duration')}
                                    description={t('Select the duration of your room booking')}
                                    size="sm"
                                  />
                                </>
                              ) : (
                                <>
                                  {t('Select the duration of')}{' '}
                                  {selectedSubService
                                    ? `${selectedSubService.name}`
                                    : selectedService
                                      ? `${selectedService.name}`
                                      : 'Service'}
                                </>
                              )}
                            </div>
                            <div
                              className={
                                'justify-center ' + (userContext?.isLandscape ? 'ml-6' : 'my-3')
                              }
                            >
                              <DurationPicker
                                selectedDuration={selectedDuration}
                                onSelectDuration={(item) => {
                                  setSelectedDuration(item);
                                }}
                                defaultValues={
                                  selectedBookingView === 'daycare'
                                    ? { step: 30, maxHours: 600 }
                                    : { step: 15, maxHours: 360 }
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <div className="pet-divider"></div>

                        <div className="booking-title available-slot-action">
                          <span>
                            {selectedBookingView === 'daycare'
                              ? t('Available check-in slots')
                              : t('Available slots')}
                          </span>
                          <div className="action-slots">
                            <BookedSlots
                              isRoomBooking={
                                selectedBookingView === 'daycare' ||
                                  selectedBookingView === 'boarding'
                                  ? true
                                  : false
                              }
                              selectedDate={selectedDate}
                              selectedServiceProviderId={selectedServiceProvider?.id}
                            />
                            <button
                              onClick={async () => {
                                if (!useSyncMutation.isLoading) {
                                  await useSyncMutation.mutateAsync({
                                    data: { businessId: user?.businessId },
                                  });
                                  fetchData();
                                }
                              }}
                              type="button"
                              className="refresh-btn-new"
                            >
                              {useSyncMutation.isLoading ? (
                                <Lottie
                                  className="progress-animation-sync schedule-loader"
                                  animationData={appCompoLoading}
                                />
                              ) : (
                                <Refreshicon />
                              )}
                            </button>
                          </div>
                        </div>
                        <div className="non-bussinesshours-booking">
                          <p>Enable this to display the non business hours / holiday slots </p>
                          <ToggleButton
                            isChecked={showNonBusinessHoursSlots}
                            onChange={() => {
                              setShowNonBusinessHoursSlots(!showNonBusinessHoursSlots);
                            }}
                            enableTwoWayBinding={false}
                          />
                        </div>
                        <div className="slot-container">
                          {useGetAvailabilitiesMutation.isLoading ? (
                            <div className="loader-slots flex items-center justify-center">
                              <Lottie animationData={appCompoLoading} />
                            </div>
                          ) : amslots &&
                            amslots?.length === 0 &&
                            pmslots &&
                            pmslots?.length === 0 ? (
                            <>
                              <div className="no-data-selected-pet-row">
                                <div className="my-3 text-center mobile-fixed-font">
                                  {t('Slots are not available')}
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <Slots
                                slots={amslots}
                                startTime={selectedTimeSlot?.start ? selectedTimeSlot?.start : null}
                                onSelectSlot={(item) => {
                                  setSelectedTimeSlot(item);
                                  // setStartTime(item.start);
                                  // setEndTime(item.end);
                                }}
                                title={t('Morning')}
                                businessData={user?.activeLocation}
                                showAllSlots={showNonBusinessHoursSlots}
                              />

                              <Slots
                                slots={pmslots}
                                startTime={selectedTimeSlot?.start ? selectedTimeSlot?.start : null}
                                onSelectSlot={(item) => {
                                  setSelectedTimeSlot(item);
                                  // setStartTime(item.start);
                                  // setEndTime(item.end);
                                }}
                                title={t('Afternoon')}
                                businessData={user?.activeLocation}
                                showAllSlots={showNonBusinessHoursSlots}
                              />
                            </>
                          )}
                        </div>
                      </>
                    )}

                    {selectedBookingView === 'grooming' &&
                      addonServices &&
                      addonServices?.length > 0 && (
                        <>
                          <div className="pet-divider"></div>
                          <div className="addons-section">
                            <div className={`heading-section left`}>
                              <h6>
                                {t('Add-on services')} <span className="new ml-2">{t('new')}</span>
                              </h6>

                              <p className="sm">
                                {' '}
                                {t('Add additional add-on services for the pet')}
                              </p>
                            </div>
                            <div>
                              <ReactSelect
                                className="multiselect-react"
                                options={addonServices ? addonServices : []}
                                isMulti={true}
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                menuPlacement={'top'}
                                classNamePrefix={'petsked-multiselect'}
                                onChange={(selected: any) => {
                                  setSelectedAddonsServices(selected);
                                }}
                                getOptionLabel={(option: any) => option.name}
                                getOptionValue={(option: any) => option.id}
                                components={{
                                  Option,
                                  ValueContainer,
                                }}
                                placeholder={t('Select add-on services')}
                                value={selectedAddonServices}
                              />
                            </div>
                            {selectedAddonServices && selectedAddonServices.length > 0 && (
                              <div>
                                <ServiceTypes
                                  services={selectedAddonServices}
                                  enableDelete={true}
                                  onDeleteService={onDeleteAddonService}
                                  restrictService={false}
                                />
                              </div>
                            )}
                          </div>
                        </>
                      )}

                    {selectedBookingView === 'grooming' && (
                      <>
                        <div className="pet-divider"></div>
                        <div className='assistand-sp-container petsked-form'>
                          <div className="form-label">{t('Assistant Groomers')}</div>
                          <Heading
                            size="sm"
                            title=""
                            description={t('Add members who wants to assist for this appointment')}
                          />
                          <div className="form-field mt-3 mb-4">
                            <ReactSelect
                              className="multiselect-react"
                              options={calenderUsers ? calenderUsers.filter((user: any) => user.id !== selectedServiceProvider?.id) : []}
                              isMulti={true}
                              closeMenuOnSelect={false}
                              hideSelectedOptions={false}
                              classNamePrefix={'petsked-multiselect'}
                              onChange={(selected: any) => {
                                setSelectedProviders(selected);
                              }}
                              getOptionLabel={(option) => option.name}
                              getOptionValue={(option) => option.id}
                              components={{
                                Option: OptionSP,
                                ValueContainer: ValueContainerSP,
                              }}
                              placeholder={t('Add Service')}
                              value={selectedProviders}
                            />
                          </div>
                          <SelectedServiceProviders
                            removeProvider={removeProvider}
                            selectedServiceProviders={selectedProviders}
                          />{' '}
                        </div>
                        <div className="pet-divider"></div>
                        <Recurring
                          selectedDuration={selectedDuration}
                          selectedSlot={selectedTimeSlot?.start}
                          selectedService={selectedService}
                          selectedServiceProvider={selectedServiceProvider}
                          onChange={(data) => {
                            setRecurringDetails(data);
                          }}
                        />
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="last-divider"></div>
              <div className="footer">
                {/* <hr /> */}
                <div className="title-and-add-btn-row mobile-full-size scroll-shadow schedule-now-btn-footer">
                  <div>
                    <span className="price-bold">
                      {currency}
                      {Utils.formatAmount(servicePrice)}
                    </span>
                    <span className="price-light">
                      {t('Total payable')} <br />
                      {`${t('(Incl. service tax)')}`}
                    </span>
                  </div>
                  <div className="schedule-now-outer">
                    <Button
                      type="button"
                      className="btn-style-new-ui no-wrap"
                      onClick={async () => {
                        scheduleAppointment();
                      }}
                      disabled={bookAppointmentMutation.isLoading}
                    >
                      {bookAppointmentMutation.isLoading ? t('Scheduling...') : t('Schedule now')}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {user?.isAdmin && showCongratsDilaog ? (
            <WelcomeDialog
              onClose={() => {
                setShowCongratsDialog(false);
                storage.clearKey('showCongratulations');
              }}
              open={showCongratsDilaog}
            ></WelcomeDialog>
          ) : null}
        </div>
      )}

      {bookingConfirmed &&
        bookingResponse &&
        ((!(selectedBookingView === 'daycare') && selectedServiceProvider) || selectedRoom) && (
          <BookAppointmentDialog
            business={businessData}
            bookingResponse={bookingResponse}
            alreadySelectedService={selectedSubService ? selectedSubService : selectedService}
            date={selectedDate}
            services={serviceList?.filter((x) => !x.isLocal)}
            startTime={moment(selectedTimeSlot?.start).toDate()}
            endTime={moment(selectedTimeSlot?.end).toDate()}
            selectedSlot={selectedSlot}
            onBookingconfirmed={() => {
              setBookingConfirmed(false);
              resetData();
              fetchData();
              onClose && onClose(false);
            }}
            selectedAddons={selectedAddonServices ? selectedAddonServices : []}
            email={email}
            phone={phone}
            serviceProvider={selectedServiceProvider}
            selectedRoom={selectedRoom}
            selectedProviders={selectedProviders}
          />
        )}
      {showAppointmentConfirmationModal && (
        <ConfirmationDialogV2
          title={selectedBookingView === 'grooming' ? t('Appointment Alert!') : t('Booking Alert!')}
          description={``}
          yesButtonLabel={t('Yes, Confirm')}
          noButtonLabel={t('No, Cancel')}
          onCancel={() => setShowAppointmentConfirmationModal(false)}
          onConfirm={() => {
            scheduleAppointment(true);
            setShowAppointmentConfirmationModal(false);
          }}
          open={showAppointmentConfirmationModal}
        >
          <div className="confirmation-alert">
            <p className="message">
              {selectedTimeSlot?.status === 'closed'
                ? t(
                  'You are trying to schedule appointment on the non business hours! Are your sure you want to schedule it?'
                )
                : selectedTimeSlot?.status === 'outside_schedule'
                  ? t(
                    'You are trying to schedule appointment outside the business hours ! Are your sure you want to schedule it?'
                  )
                  : t(
                    'There is a holiday in the range you have selected , Are you sure you still want to continue with booking the appointments?'
                  )}
            </p>
          </div>
        </ConfirmationDialogV2>
      )}
    </>
  );
};
const Option = (props: any) => {
  const {
    data: { name, description, price },
  } = props;
  const { t, i18n } = useTranslation();
  const { user } = useAuth();
  const currency = businessCurrency(user, 'USD');
  return (
    <div key={`options-sp${props.value}`}>
      <components.Option {...props}>
        <div className="addons-option flex items-center justify-between">
          <div className="left-section">
            <label className="name">{name}</label>
            <p className="desc" title={description}>
              {description}
            </p>
          </div>
          <div className="right-section">
            <span className="price">
              + {currency}
              {Utils.formatAmount(price)}
            </span>
            <label
              htmlFor={`option-check-${props.value}`}
              className="check-container"
              onClick={(e) => {
                e.preventDefault();
              }}
            >
              <input
                checked={props.isSelected}
                id={`option-check-${props.value}`}
                type="checkbox"
              />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>
      </components.Option>
    </div>
  );
};
const ValueContainer = (props: any) => {
  const { getValue, hasValue, selectProps, children } = props;
  const countSelectedVal = getValue().length;
  return (
    <components.ValueContainer {...props}>
      {countSelectedVal > 0 &&
        !props.selectProps.inputValue &&
        `+${countSelectedVal} Service${countSelectedVal != 1 ? 's' : ''} added`}
      {React.Children.map(children, (child) =>
        !hasValue || child.type === components.Input ? child : null
      )}
    </components.ValueContainer>
  );
};

// const ValueContainer = (props: any) => {
//   const valueLength = props.getValue().length;
//   return (
//     <components.ValueContainer {...props}>
//       {valueLength === 0 && (
//         <span className="react-select-custom-placeholder">Select Add on services</span>
//       )}
//       {valueLength > 0 &&
//         !props.selectProps.inputValue &&
//         `+${valueLength} Service${valueLength != 1 ? 's' : ''} added`}
//       {React.Children.map(props.children, (child) => {
//         return child && child.type === components.Input ? child : null;
//       })}
//     </components.ValueContainer>
//   );
// };
